export default {
  layout: {
        zh: '简体中文',
        tc: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
  },
  footer: {},
  menu: {
      home: 'ホーム',
      mining: 'マイニング機',
      wallet: 'ウォレット',
      me: 'マイページ',
      login: 'ログイン'
  },
  home: {
      buy: '購入',
      dailyEarnings: '当日収益',
      topUp: 'チャージ',
      desc: '製品パラメータ：隠れた成長と大きな成功のために設計',
      popup: {
          buy: '今すぐ購入',
          desc: 'マイニング機収益：日額1%のリターン（1日3U）。収益受け取りには30日ごとにデータカプセル（35U）の支払いが必要、データカプセル1個付属',
          totalAmount: '総金額',
          wallet: '資金ウォレット',
          revenue: '収益ウォレット',
          pls: '収益ウォレットで支払い',
          config: 'ウォレット設定',
          most: '最大使用量',
          confirmPurchase: '購入確定',
          plsDes: '紹介者を入力',
          confirm: '確定',
      }
  },
  mining: {
      title: 'マイニング機リスト',
      day: '当日総生産量',
      activate: '活性化待ちデータカプセル(個)',
      miningrig: '保有マイニング機(台)',
      output: '生産中',
      dataCapsule: 'データカプセル',
      time: '購入時間',
      remaining: '残り日数(日)',
      today: '本日の生産量',
      total: '総生産量',
      expired: '間もなく期限切れ',
      stop: '生産停止',
  },
  record: {
      title: 'アカウント記録',
      empty: '記録なし',
      wallet: '資金ウォレット',
      time: '日付',
      remark: '備考：ポイント別発行',
      complimentary: '備考：プレゼント',
      static: '備考：静的収益',
  },
  wallet: {
      title: 'マイウォレット',
      record: '資金記録',
      static: '当日静的収益',
      dynamic: '当日動的報酬',
      topup: 'チャージ',
      withdraw: '引き出し',
      totalRevenue: 'マイニング機総収益',
      totalReward: '総報酬',
      funds: '資金ウォレット',
          fund1: '資金ウォレット',
        fund2: 'リターン ウォレット',
        fund3: '配分 ウォレット',
  },
  withdraw: {
      title: '引き出し',
      revenue: '収益ウォレット',
      amount: '引き出し金額',
      confirm: '引き出し確定',
      rule: '引き出しルール',
      desc: '引き出し手数料：取引ごとに5Uまたは5%、高い方を基準',
      desc1: '最低引き出し金額：10U',
      list: '引き出しリスト',
      success: '成功',
      time: '日付',
      error: '失敗',
  },
  me: {
      recommend: 'マイ紹介者',
      subscription: '購入実績',
      directReferral: '直接紹介実績',
      team: 'マイチーム(人)',
      performance: 'チーム実績',
      serialNumber: 'シリアル番号',
      level: 'レベル',
      individual: '個人実績',
      time: '登録日',
      home: 'ホーム',
      last: '最後',
  },
};